module.exports = __webpack_public_path__ + "img/lessonpre_narrow_combo_normal.b4e5689d.svg";